import { FormikContextType } from 'formik'

import { TextFieldProps } from '@mui/material'
import { getFormError } from '@/utils/forms'

import { ConsoleTextField } from '../StyledInputComponents'

type FieldProps<Values> = Omit<TextFieldProps, 'name' | 'value'> & {
  formik: FormikContextType<Values>
  name: keyof Values & string
  validateFormOnBlur?: boolean
  disabledProperties?: Array<keyof Values & string>
}

export const FormikTextField = <Values extends NonNullable<unknown>>({
  name,
  formik,
  validateFormOnBlur,
  disabledProperties,
  disabled,
  ...props
}: FieldProps<Values>) => {
  return (
    <ConsoleTextField
      onChange={formik.handleChange}
      onBlur={() => {
        formik.setFieldTouched(name, true, true)
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        validateFormOnBlur && formik.validateForm()
      }}
      name={name}
      autoComplete="off"
      value={formik.values[name]}
      error={getFormError(formik, name)}
      disabled={disabled || disabledProperties?.includes(name)}
      {...props}
    />
  )
}
